import { ENDPOINT_REQUEST, sendMsg, SERVICES_REQUEST } from "../../configurations";

export const stockServices = {
	getInstrumentDetailService,
	getSpreadTableService,
	getGoodTillDateService,
};

function getInstrumentDetailService(params, callback) {
	sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.STOCK.GET_INSTRUMENT_DETAIL.format(params.instrumentID), params).get((res) => {
		callback(res);
	});
}

function getSpreadTableService(params, callback) {
	sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.STOCK.GET_SPREAD_TABLE, params).get((res) => {
		callback(res);
	});
}

function getGoodTillDateService(params, callback) {
	sendMsg(SERVICES_REQUEST.EQT, ENDPOINT_REQUEST.iTRADE.STOCK.GET_GOOD_TILL_DATE, params).get((res) => {
		callback(res);
	});
}
